module.exports = "https://bin.bnbstatic.com/_next/static/images/usdt_web_en-870e257c9d40f409caa0f07ef37375fb.png";